//
import { get } from "lodash";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsFillArrowLeftSquareFill, BsFillClockFill } from "react-icons/bs";
import RightArrow from "src/assets/images/transfer/right-arrow.gif";
import { FcCancel } from "react-icons/fc";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useQueryDetailDeposit from "src/hooks/useQueryDetailDeposit";
import { DepositPics, IAccountForm, TransferOpinion } from "src/types";
import {
  dateToLocal,
  dateToLocalComplete,
  dateToLocalHour,
  getDollarOneImg,
  getFiatName,
  getHourDateExpirate,
  getProfileDefaultImage,
  money,
} from "../../../helpers/mixins";
import DepositStatus from "../../Shared/DepositStatus";
import SkeletonDepositDetail from "../../Shared/Skeletons/SkeletonDepositDetail";
import UploadManyFiles from "src/components/Shared/DepositUploadManyFiles";
import { useAppStateContext } from "src/auth/AppStateContext";

import { Popover, Tooltip } from "antd";
import DialogConfirm from "src/components/Shared/DialogInfoGeneral";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import APIService from "src/services/Api";
import { ImSpinner9 } from "react-icons/im";
import GalleryPics from "src/components/Shared/GalleryPics";
import ViewDepositStatus from "src/components/Shared/ViewDepositStatus";
import { UseAuth } from "src/auth/AuthContext";

import OpenChatTransfer from "src/components/Shared/OpenChatTransfer";
import AppealResume from "src/components/System/AppealResume";
import { IoCloseCircleSharp, IoStar } from "react-icons/io5";
import FormatLastConnection from "src/components/Shared/FormatLastConnection";

const DepositDetail: React.FC = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { transferId } = useParams();
  const navigate = useNavigate();
  const { user } = UseAuth();
  //@ts-ignore
  const { depositDetail, loading } = useQueryDetailDeposit(
    state?.id || transferId
  );
  const answers = [
    "información incorrecta en los detalles proporcionados",
    "dinero no recibido",
    "dinero incompleto",
  ];
  const { processors, fetchProccesors } = useAppStateContext();
  //const [usercountry, setUsercountry] = useState<string>("");
  const [loadingUploadPics, setLoadingUploadPics] = useState<boolean>(false);
  const [status, setStatus] = useState<string>();
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [successCancel, setSuccessCancel] = useState<string>("");
  const [opinion, setOpinion] = useState<TransferOpinion>();
  const [commentCancel, setCommentCancel] = useState<string>();
  const [cashierReceivedMoney, setCashierReceivedMoney] = useState<string>("");
  const [methodPayment, setMethodPayment] = useState<IAccountForm>();
  const [pics, setPics] = useState<DepositPics[]>([]);

  const [showDialogRefusePayment, setShowDialogRefusePayment] =
    useState<boolean>(false);
  /*   const [showDialogIncompletePayment, setShowDialogIncompletePayment] =
    useState<boolean>(false); */
  useEffect(() => {
    setStatus(get(depositDetail, "status", ""));
    //setUsercountry(get(depositDetail, "user.country", ""));
    setMethodPayment(JSON.parse(depositDetail?.accountsendstringify || "{}"));
  }, [depositDetail]);

  useEffect(() => {
    setCashierReceivedMoney("");
  }, []);

  useEffect(() => {
    if (depositDetail && status) {
      fetchPics(depositDetail?.id?.toString() || "");
    }
  }, [depositDetail, status]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (depositDetail && status) {
        fetchPics(depositDetail?.id);
      }
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleCommentCancel = (c: string) => {
    if (c.length > 200) {
      c = c.substring(0, 200);
    }
    setCommentCancel(c);
  };

  const handleSuccessCancel = () => {
    setShowDialogRefusePayment(false);
    setSuccessCancel("");
    setCashierReceivedMoney("refused");
  };

  const handleRefuseTransfer = async () => {
    setLoadingCancel(true);
    const data = {
      deposit: depositDetail?.id || "",
      newstatus: "refused",
      origen: "cashier",
      motive: commentCancel,
    } as any;
    /* if (newStatus === "cancel" || newStatus === "refused") {
      data.motive = motive;
    } */
    const updated = await APIService.systemDepositUpdateStatus(data);
    if (updated.data.status) {
      setCashierReceivedMoney("");
      setStatus("refused");
      setSuccessCancel("yes");
    } else {
      setSuccessCancel("no");
    }
    setLoadingCancel(false);
  };

  const [anwersConfirmRefused, setAnwersConfirmRefused] = useState(false);

  const openMotiveWindow = () => {
    setCommentCancel("");
    setShowDialogRefusePayment(true);
  };

  const fetchPics = async (depositId: string) => {
    const x = await APIService.depositListAnyPic({ depositId });
    const p = x?.data?.data as DepositPics[];
    setPics(p);
  };

  const closeDialogRefuse = () => {
    setShowDialogRefusePayment(false);
    setCashierReceivedMoney("");
  };
  const fetchOpinion = async () => {
    const fetch = await APIService.depositOpinionDetail({
      depositId: transferId,
    });
    const opinion = fetch?.data?.data?.opinion;
    setOpinion(opinion);
    /*if(!opinion){
      setShowFeedBack(true)
    }*/
  };

  const closeWindowUpload = () => {
    window.setTimeout(() => {
      fetchPics(depositDetail?.id || "");
    }, 3000);
    if (status === "completed") {
      setCashierReceivedMoney("");
    }
    setStatus(status === "refused" ? "refused" : "completed");
  };

  useEffect(() => {
    setCashierReceivedMoney("");
  }, [transferId]);

  useEffect(() => {
    if (status === "completed") {
      fetchOpinion();
    }
  }, [status]);
  useEffect(() => {
    if ((processors?.length || 0) === 0) {
      fetchProccesors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processors]);
  useEffect(() => {
    setAnwersConfirmRefused(false);
  }, [showDialogRefusePayment]);

  return (
    <Fragment>
      <div
        className="h-64 w-full bg-cover rounded-md"
        style={{ backgroundImage: `url(${getDollarOneImg()})` }}
      ></div>
      <div className="relative -top-36">
        {!loading ? (
          <>
            <section className="bg-white rounded-md px-4 md:px-12 border border-stone-150 shadow-md py-4 w-full md:w-10/12 mx-auto rounded-t-xl">
              <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-300 border-dashed pb-2  mb-4 ">
                <div className="text-lg grid-col-1 font-medium flex items-center gap-x-2">
                  <div
                    onClick={() => navigate(-1)}
                    className="font-semibold cursor-pointer"
                  >
                    <BsFillArrowLeftSquareFill
                      size={29}
                      className="text-dark-green"
                    />
                  </div>
                  {t("depositdetail.detail")} {depositDetail?.code}
                </div>
                <div className="font-medium grid-col-1 flex items-center justify-between">
                  <div>
                    {t("date")} {t("creation")}
                  </div>
                  <div>{dateToLocal(depositDetail?.createdAt)} </div>
                  <div className="font-medium">
                    {t("hour")}: {dateToLocalHour(depositDetail?.createdAt)}
                  </div>
                </div>
              </div>
              {depositDetail && (
                <div
                  className="grid grid-cols-1 lg:grid-cols-3 borderssh -L 5000:127.0.0.1:5000 root@154.223.16.157
                -b text-center bg-gradient-card opensans lg:text-left border-gray-300 border-dashed pb-2  mb-4 w-full border border-gray-300 flex items-center py-2 px-2 rounded-md bg-white text-sm font-medium"
                >
                  <div className="flex flex-col lg:flex-row col-span-2">
                    <div className="grid grid-cols-1 lg:grid-cols-2 ">
                      <div>
                        <div>
                          <div>
                            {transferId === user?.id
                              ? "Has ganado"
                              : "Ganacia del cajero"}
                          </div>
                          <div className="bg-stone-300 rounded-md px-2 py-1 md:mx-none mx-auto w-fit my-1">
                            ${depositDetail?.profitcashier} USD.
                          </div>
                        </div>
                        {user?.role === "admin" && (
                          <div>
                            Porcentaje aplicado
                            <div className="bg-stone-300 rounded-md px-2 py-1 md:mx-none mx-auto w-fit my-1">
                              {depositDetail?.percentcashier}%.
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="">
                        <div>
                          Swap de transferencia
                          <div className="bg-stone-300 rounded-md px-2 py-1 md:mx-none mx-auto w-fit my-1">
                            ${depositDetail?.profithouse}
                          </div>
                        </div>
                        {user?.role === "admin" && (
                          <div className="mt-2">
                            Porcentaje de la casa
                            <div className="bg-stone-300 rounded-md px-2 py-1 md:mx-none mx-auto w-fit my-1">
                              {depositDetail?.percenthouse}%
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="text-xs opensans ">
                      Los cálculos de la transferencia se realizaron utilizando
                      valor USD del fiat {depositDetail?.currentusd}
                    </div>
                  </div>
                </div>
              )}
              <div className="text-center font-bold text-sx opensans py-2">
                Usuario responsable de la transferencia.
              </div>
              <div className="w-full grid lg:grid-cols-4 items-center gap-1 py-2 px-2 rounded-md bg-white mb-2">
                <div className="col-span-2 ">
                  <Popover
                    placement="top"
                    content={
                      <div className="font-bold">
                        Usuario responsable de la transferencia
                      </div>
                    }
                    trigger="hover"
                  >
                    <div className="flex flex-col md:flex-row items-center gap-2 justify-center md:justify-start">
                      <div
                        className="w-16 h-16 bg-cover bg-center rounded-full"
                        onClick={() =>
                          navigate(`/usuario/${depositDetail?.user?.id}`)
                        }
                        style={{
                          backgroundImage: `url(${
                            (depositDetail?.user?.photoUrl?.length || 0) > 0
                              ? process.env.REACT_APP_PROFILEPICTURE +
                                (depositDetail?.user?.photoUrl || "")
                              : getProfileDefaultImage()
                          })`,
                        }}
                      ></div>
                      <div></div>
                      <div className=" text-sm md:text-base text-center md:text-left ">
                        <div
                          onClick={() =>
                            navigate(`/usuario/${depositDetail?.user.id}`)
                          }
                          className="font-semibold cursor-pointer underline text-sky-600"
                        >
                          {depositDetail?.user.fullname}
                        </div>
                        <div>
                          <span className="text-sm font-medium">
                            última conexión
                          </span>{" "}
                          <span className="bg-white text-xs font-semibold text-black">
                            {FormatLastConnection({
                              lastConnection:
                                depositDetail?.user?.lastConnection,
                            })}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Popover>
                </div>
                <div className="col-span-1 text-xs">
                  {/*  <div className="font-normal">
                  <div className="font-normal">
                    {t("country")}:{" "}
                    {countries.find((c) => c.code === usercountry)?.name}{" "}
                  </div>
                    {t("phone")}:{" "}
                    {countries.find((c) => c.code === usercountry)?.dial_code}{" "}
                    {depositDetail?.user.phone}
                  </div> */}
                  <div>
                    {transferId && depositDetail && (
                      <OpenChatTransfer
                        destinyPhotoUrl={depositDetail?.user?.photoUrl || ""}
                        destinyFullname={depositDetail?.user?.fullname || ""}
                        destinyLastConnection={
                          depositDetail?.user?.lastConnection || ""
                        }
                        status={depositDetail?.status || ""}
                        depositId={transferId}
                      />
                    )}
                  </div>
                </div>
                <div className="col-span-1">
                  {depositDetail?.status === "waitpay" && (
                    <Fragment>
                      <div className="text-xs flex w-fit mx-auto justify-between items-center px-2 py-1 font-normal rounded-sm bg-red-100 border-r-4 border-red-500 text-black">
                        <BsFillClockFill size={20} className="mr-2" />{" "}
                        {t("deposits.thiswillcancel")}{" "}
                        {getHourDateExpirate(
                          dateToLocalComplete(
                            depositDetail?.createdAt
                          ).toString(),
                          parseInt(depositDetail?.timeinhour)
                        )}
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>

              {(depositDetail?.systemProcessor?.name
                ?.toLowerCase()
                .includes("weltrade") ||
                depositDetail?.destinyProcessor?.name
                  ?.toLowerCase()
                  .includes("weltrade")) && (
                <div className="py-2 px-4 bg-gradient-amber  my-2 text-base font-bold text-center opensans">
                  Esta transferencia representa un{" "}
                  {depositDetail?.systemProcessor?.name
                    ?.toLowerCase()
                    .includes("weltrade")
                    ? "retiro weltrade"
                    : "deposito weltrade"}
                </div>
              )}

              {depositDetail && (
                <div className="grid grid-cols-1 gap-y-2">
                  <div className="w-full bg-gradient-card border border-gray-300 flex items-center py-2 px-2 rounded-md bg-white">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 w-full">
                      <div className="col-span-2 flex items-center justify-center lg:justify-start">
                        <div className="mr-2">
                          <RiMoneyDollarCircleFill
                            size={60}
                            className="text-dark-green"
                          />
                        </div>
                        <div>
                          <div className="font-bold relative text-base">
                            {t("table.willget")}: ${money(depositDetail?.money)}{" "}
                            {getFiatName(
                              depositDetail?.systemProcessor.id,
                              processors
                            )}
                            {/*                             <div>
                              En USD:{" "}
                              {(
                                Number(depositDetail?.money) /
                                Number(depositDetail?.currentusd)
                              ).toFixed(2)}
                            </div> */}
                            <img
                              alt="rightArrow"
                              src={RightArrow}
                              className="hidden lg:block  absolute -right-20 w-12"
                            />
                          </div>
                          <div>
                            <img
                              alt="procesador"
                              className="w-auto h-14"
                              src={`${process.env.REACT_APP_PROCESSOR_IMAGE}${depositDetail?.systemProcessor?.photoUrl}`}
                            />
                          </div>
                          <div className="font-medium">
                            <div>{t("paymethod")}</div>
                            <div className="font-semibold">
                              {depositDetail?.systemProcessor?.name ||
                                t("nodata")}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-span-2 flex flex-col  items-center lg:items-start">
                        <div className="font-bold text-base">
                          {t("totalpay")}: ${money(depositDetail?.totaltopay)}{" "}
                          {getFiatName(
                            depositDetail?.destinyProcessor.id,
                            processors
                          )}
                        </div>
                        <div className="font-semibold">
                          {t("paymethod")}{" "}
                          <img
                            alt="procesador"
                            className="w-auto h-14"
                            src={`${process.env.REACT_APP_PROCESSOR_IMAGE}${depositDetail?.destinyProcessor?.photoUrl}`}
                          />
                        </div>
                        <div className="font-semibold">
                          {
                            (
                              JSON.parse(
                                depositDetail?.accountsendstringify
                              ) as IAccountForm
                            )?.number
                          }
                        </div>
                        <div className="font-semibold">
                          {((
                            JSON.parse(
                              depositDetail?.accountsendstringify
                            ) as IAccountForm
                          )?.typered?.length || 0) > 0 &&
                            `Red: ` +
                              ((
                                JSON.parse(
                                  depositDetail?.accountsendstringify
                                ) as IAccountForm
                              )?.typered || "---")}
                        </div>
                        {(
                          JSON.parse(
                            depositDetail?.accountsendstringify
                          ) as IAccountForm
                        )?.accounttype && (
                          <div className="font-semibold">
                            {t(
                              `bankaccounttype.${
                                (
                                  JSON.parse(
                                    depositDetail?.accountsendstringify
                                  ) as IAccountForm
                                )?.accounttype
                              }`
                            )}
                          </div>
                        )}
                        <div className="font-bold">
                          {(methodPayment?.nametitular?.length || 0) > 0 &&
                            `Titular:`}{" "}
                          {methodPayment?.nametitular}{" "}
                          {methodPayment?.identificationtype &&
                            methodPayment?.identificationtype}{" "}
                          {methodPayment?.identification &&
                            methodPayment?.identification}
                        </div>

                        <div className="font-medium flex items-center mt-2 pt-2 pb-2 border-t border-stone-200">
                          {t("status")}:{" "}
                          {status &&
                            (user?.role === "admin" ? (
                              <DepositStatus
                                userId={depositDetail?.user.id}
                                depositId={depositDetail?.id}
                                depositCode={depositDetail?.code}
                                currentStatus={status || ""}
                                moneyFrom={`${money(
                                  depositDetail?.money
                                )} ${getFiatName(
                                  depositDetail?.systemProcessor.id,
                                  processors
                                )}`}
                                moneyTo={`${money(
                                  depositDetail?.totaltopay
                                )}${getFiatName(
                                  depositDetail?.destinyProcessor.id,
                                  processors
                                )}`}
                              />
                            ) : (
                              <ViewDepositStatus currentStatus={status} />
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {depositDetail?.depositAppeal && (
                <AppealResume
                  commentByAdmin={depositDetail?.depositAppeal?.commentByAdmin}
                  commentByUser={depositDetail?.depositAppeal?.commentByUser}
                />
              )}

              {opinion?.calification && (
                <div className="text-base font-medium border-t mb-4 pb-4 py-2 mt-2 opensans text-center border-b border-dashed border-stone-400">
                  <div className="text-base font-normal mb-4">
                    calificación del servicio
                  </div>
                  <div className="grid md:grid-cols-2">
                    <div className="flex items-center text-xl opensans font-normal gap-2 justify-center">
                      {Number(opinion?.calification || 0).toFixed(1)}
                      <div className="flex items-center justify-center gap-0">
                        {Array.from(
                          new Array(opinion?.calification).keys()
                        ).map((c) => (
                          <IoStar
                            key={c}
                            size={30}
                            className="text-amber-300"
                          />
                        ))}
                      </div>
                    </div>
                    {(opinion?.comment?.length || 0) > 0 && (
                      <div className=" bg-gradient-amber px-2 py-2 font-medium text-left opensans lowercase rounded-md">
                        <div className="text-xs">
                          Comentario enviado por el cliente
                        </div>
                        <div className="px-2">{opinion?.comment}</div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="text-center uppercase font-bold opensans py-4 mt-2">
                Comprobantes de pago
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-2 mt-2 mb-20">
                <div className="col-span-1">
                  <div>
                    <div className="w-full bg-gray-card border border-stone-200 py-2 px-2 rounded-md shadow-md flex flex-col justify-center">
                      <div className="text-center border-b border-stone-400 border-dashed font-bold uppercase opensans px-2 py-2 text-sm md:text-base ">
                        {user?.role === "cashier" &&
                          "Mis comprobantes (cajero)"}
                        {user?.role === "admin" &&
                          "Archivos enviados por el cajero"}
                      </div>
                      <div className="text-center font-medium pt-4 pb-1 ">
                        {status === "completed" &&
                          "La transacción a finalizado"}
                        {status === "refused" &&
                          "La transacción ha sido rechazada"}
                        {status === "appeal" &&
                          "La transacción se encuentra en un estado de revisión"}
                      </div>

                      {status === "checking" && cashierReceivedMoney === "" && (
                        <>
                          <div className="mx-auto flex opensans flex-col gap-1 text-center mt-2 bg-gradient-card border border-stone-300 rounded-md py-2 w-full px-2 mt-2">
                            <div className="font-semibold text-base mb-2  ">
                              ¿Recibiste el pago del cliente?
                            </div>
                            <div className="flex text-base justify-center items-center gap-2">
                              <div
                                onClick={() => setCashierReceivedMoney("true")}
                                className="bg-green-admin-light flex items-center gap-2 text-white w-fit px-4 py-2 text-sm rounded-sm font-bold cursor-pointer"
                              >
                                Sí. Confirmado <AiOutlineLike size={22} />
                              </div>
                              <div
                                onClick={() => (
                                  openMotiveWindow(),
                                  setCashierReceivedMoney("false")
                                )}
                                className="bg-[#000] text-white flex items-center gap-2 w-fit px-4 py-2 text-sm rounded-sm font-bold cursor-pointer"
                              >
                                No. <AiOutlineDislike size={22} />
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {(pics?.filter((p) => p.responsable === "cashier")
                        ?.length || 0) === 0 &&
                        status === "checking" &&
                        cashierReceivedMoney != "" && (
                          <div className="w-full">
                            {status === "checking" &&
                              !loading &&
                              !loadingUploadPics && (
                                <Tooltip placement="right" title="Regresar">
                                  <div
                                    onClick={() => setCashierReceivedMoney("")}
                                    className="relative"
                                  >
                                    <IoCloseCircleSharp
                                      size={27}
                                      className="absolute text-red-400 cursor-pointer -right-4 top-0"
                                    />
                                  </div>
                                </Tooltip>
                              )}
                            <div className="w-full text-left font-medium text-sm py-4">
                              <UploadManyFiles
                                success={() => closeWindowUpload()}
                                type="cashierpayment"
                                currentStatus={status || ""}
                                transferId={depositDetail?.id || ""}
                                newStatus={"completed"}
                                setLoadingUpload={setLoadingUploadPics}
                              />
                            </div>
                          </div>
                        )}
                      {
                        <GalleryPics
                          title={`Transferencia ${
                            depositDetail?.code
                          } por el valor de ${money(
                            depositDetail?.totaltopay || 0
                          )}`}
                          description={`Comprobante de pago enviado por el cajero ${depositDetail?.cashier?.fullname}`}
                          photoUrl={pics?.filter(
                            (p) => p.responsable === "cashier"
                          )}
                          code={depositDetail?.code}
                        />
                      }
                    </div>
                  </div>
                </div>

                <div className="col-span-1 bg-gray-card border border-stone-200 py-2 px-2 rounded-md shadow-md">
                  <div className="font-bold uppercase opensans py-2 text-sm md:text-base text-black border-b border-stone-400 border-dashed text-center ">
                    Comprobantes de pago (cliente)
                  </div>
                  {(status === "cancel" || status === "refused") && (
                    <Fragment>
                      <div className="w-full text-left">
                        <div className="flex items-center text-center text-base font-semibold py-3 justify-center">
                          Estado de la transferencia:{" "}
                          {t(`depositstatus.${status}`)}{" "}
                          <FcCancel size={23} className="ml-1" />
                        </div>
                        <div className="border border-stone-200 bg-stone-200 rounded-md px-2 py-2">
                          {t("motiveseted")}
                          <div className="font-semibold">
                            {depositDetail?.motive}
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  )}
                  {status === "waitpay" && (
                    <div className="font-semibold opensans text-center mt-4 text-black">
                      {t("withoutpay")}.
                    </div>
                  )}
                  {status !== "waitpay" && (
                    <div>
                      <div className="font-normal text-black text-center pt-2 opensans">
                        {t("paysent")}
                      </div>
                      <div>
                        <div className="relative flex justify-center py-2 px-2">
                          <div className="w-full flex flex-col justify-center items-center mx-auto">
                            <GalleryPics
                              title={`Transferencia ${
                                depositDetail?.code
                              } por el valor de ${money(
                                depositDetail?.money || 0
                              )}`}
                              description={`Comprobante de pago enviado por ${depositDetail?.user?.fullname}`}
                              photoUrl={pics.filter(
                                (p) =>
                                  p.responsable === "user" &&
                                  (user?.role === "cashier"
                                    ? p.type !== "evidence"
                                    : true)
                              )}
                              code={depositDetail?.code}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>

            <DialogConfirm
              show={showDialogRefusePayment}
              disabledFooter={true}
              size="xl"
              disabledClosable={true}
              closeDialog={() => closeDialogRefuse()}
            >
              <div className="grid grid-cols-3">
                <div className="md:px-20 md:10 py-4 col-span-3 md:col-span-2  opensans">
                  <div className="text-base md:text-lg text-left mb-6 font-semibold">
                    {!anwersConfirmRefused ? (
                      <>
                        {successCancel !== "yes" && (
                          <div className="text-base  pt-7 font-semibold">
                            ¿Confirmas que no has recibido el pago completo $
                            {money(depositDetail?.money)}{" "}
                            {getFiatName(
                              depositDetail?.systemProcessor.id,
                              processors
                            )}{" "}
                            ?
                          </div>
                        )}
                      </>
                    ) : (
                      <span className="fadeintop">
                        El cliente será notificado de la cancelación de su
                        transferencia.
                      </span>
                    )}
                  </div>
                  {successCancel === "" && (
                    <div className="w-100">
                      <div className="text-left font-semibold  text-base mb-8">
                        Escribe el motivo del rechazo para el cliente:
                      </div>
                      <div className="border-b border-stone-300 border-dashed pb-1 mb-2">
                        También puedes elegir una respuesta predeterminada.
                      </div>
                      {answers.map((a, k) => (
                        <div
                          className="border cursor-pointer border-stone-50 hover:bg-emerald-400  transition-all w-fit px-2 py-1 bg-stone-200 rounded-md text-sm opensans"
                          onClick={() => setCommentCancel(a)}
                          key={k.toString()}
                        >
                          {a}
                        </div>
                      ))}
                      <div className="w-full md:w-9/12 mt-4">
                        <div>O escribir tu propia respuesta.</div>
                        <textarea
                          placeholder="Escribe acá el mensaje..."
                          maxLength={200}
                          value={commentCancel}
                          onChange={(e) => handleCommentCancel(e.target.value)}
                          className="bg-stone-200 border border-stone-300 placeholder-gray-800 w-full h-20 rounded-md px-3 py-2 text-base font-medium"
                        ></textarea>
                        <div className="text-gray-400">
                          {commentCancel?.length}/200
                        </div>
                      </div>
                    </div>
                  )}
                  {successCancel === "" && (
                    <div className="flex flex-row  items-center gap-6 mt-6 mb-4 justify-start">
                      {(commentCancel?.length || 0) > 2 && (
                        <button
                          onClick={() =>
                            !loadingCancel ? handleRefuseTransfer() : null
                          }
                          className="bg-green-admin-light font-medium shadow-sm border border-emerald-800 text-white text-base px-2 py-2 rounded-md"
                        >
                          {!loadingCancel ? (
                            "Rechazar la transferencia."
                          ) : (
                            <ImSpinner9 className="animate-spin" size={22} />
                          )}
                        </button>
                      )}
                      {!loadingCancel && (
                        <button
                          onClick={() => closeDialogRefuse()}
                          className="bg-stone-200 hover:bg-stone-300 font-medium shadow-sm border border-stone-400 text-base px-2 py-2 rounded-md"
                        >
                          Cancelar
                        </button>
                      )}
                    </div>
                  )}

                  {successCancel === "yes" && (
                    <div className="py-4 flex items-center justify-center opensans flex-col">
                      <div className="py-2 text-xl mb-4 font-medium text-center">
                        La trasferencia ha sido rechazada con éxito
                      </div>
                      <button
                        onClick={() => handleSuccessCancel()}
                        className="bg-green-admin-light font-bold mx-auto text-white text-sm px-2 py-2 rounded-sm"
                      >
                        Aceptar
                      </button>
                    </div>
                  )}

                  {successCancel === "no" && (
                    <div className="py-4 flex items-center opensans justify-center flex-col">
                      <div className="py-2 text-xl font-medium text-center">
                        No fue posible rechazar la transferencia, intente
                        nuevamente.
                      </div>
                      <button
                        onClick={() => handleSuccessCancel()}
                        className="bg-green-admin-light font-bold mx-auto text-white text-sm px-2 py-2 rounded-sm"
                      >
                        Aceptar
                      </button>
                    </div>
                  )}
                </div>
                <div className="col-span-3 md:col-span-1 px-4 md:10 py-4 border-t-2 md:border-t-0 md:border-l border-dashed border-stone-400 text-center md:text-left">
                  <div className="text-lg font-semibold mb-4">
                    A tener en cuenta:
                  </div>
                  <div className="text-base text-stone border-b border-stone-400 border-dashed mb-2 pb-4 font-normal">
                    Si confirmas que no has recibido el pago, la transferencia
                    será rechazada y se notificará al cliente.
                  </div>
                  <div className="mt-4 font-normal text-sm">
                    Pasos para rechazar la transferencia.
                  </div>
                  <div className="mt-4 font-normal text-sm">
                    1. Escribe un motivo por el cuál rechazas la transferencia.
                  </div>
                  <div className="font-normal text-sm mt-2 mb-6">
                    2. Presiona el botón 'Rechazar la transferencia' para
                    finalizar el proceso.
                  </div>
                </div>
              </div>
            </DialogConfirm>
          </>
        ) : (
          <section className="w-11/12 mx-auto">
            <SkeletonDepositDetail />
          </section>
        )}
      </div>
    </Fragment>
  );
};
export default DepositDetail;
